import TR from 'utils/TR';
import T from 'utils/T';
import ex from 'utils/ex';
import HBox from 'components/common/HBox';
import VBox from 'components/common/VBox';

export default function TIRBar(props) {
  const {
    tar = 0,
    tir = 0,
    tbr = 0,
  } = props;

  const sum = (+tar) + (+tir) + (+tbr);
  return (
    <HBox full vstretch {...ex('TIRBar', props)}>
      <VBox full>
        <HBox vend>
          <div>
            {T('{0}', tar)}
          </div>
          <div>
            {T('%')}
          </div>
        </HBox>
        <HBox vend>
          <div>
            {T('{0}', tir)}
          </div>
          <div>
            {T('%')}
          </div>
        </HBox>
        <HBox vend>
          <div>
            {T('{0}', tbr)}
          </div>
          <div>
            {T('%')}
          </div>
        </HBox>
      </VBox>
      <VBox>
        <div {...{ style: { height: `${sum === 0 ? 33.333333333 : tar / sum * 100}%` } }} />
        <div {...{ style: { height: `${sum === 0 ? 33.333333333 : tir / sum * 100}%` } }} />
        <div {...{ style: { height: `${sum === 0 ? 33.333333333 : tbr / sum * 100}%` } }} />
      </VBox>
    </HBox>
  );
}
